import React from "react";
import flowers from "../data/optmartie";
import FlowerContainer from "../components/FlowerContainer";

const OptMartie = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Buchete pentru 8 Martie"
      subtitle="Oferă un buchet plin de prospețime și culoare pentru a sărbători femeile speciale din viața ta."
      storageKey="OPTMARTIE_SCROLL_POSITION"
    />
  );
};

export default OptMartie;
